export const surveyAccounts = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_SURVEY_ACCOUNTS': {
      const newState = { ...state };
      const { surveyId, accounts } = action.payload;

      accounts.forEach((account) => {
        newState[surveyId] = {
          ...(newState[surveyId] || {}),
          [account.id]: account,
        };
      });

      return newState;
    }
    case 'REMOVE_SURVEY_ACCOUNTS': {
      const newState = { ...state };
      const { surveyId, accounts } = action.payload;

      accounts.forEach((account) => {
        delete newState[surveyId][account.id];
      });

      return newState;
    }
    default:
      return state;
  }
};
